/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Missiontitle1Inputs */

const zh_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使命`)
};

const en_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mission`)
};

const es_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misión`)
};

/**
* | output |
* | --- |
* | "Mission" |
*
* @param {About_Missiontitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_missiontitle1 = /** @type {((inputs?: About_Missiontitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Missiontitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_missiontitle1(inputs)
	if (locale === "en") return en_about_missiontitle1(inputs)
	return es_about_missiontitle1(inputs)
});
export { about_missiontitle1 as "about_missionTitle" }